<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<button
  (click)="openLinks()"
  type="button"
  class="btn btn-info btn-ico"
  [ngbTooltip]="'LINKS_BUTTON.LINKS' | translate"
  container="body"
>
  <i class="fal fa-external-link"></i>
</button>
